// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box_jXYTl::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  border-radius: 5px;
}
.box_jXYTl::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
}
.box_jXYTl::-webkit-scrollbar-thumb {
  background-color: #979797;
  border: 2px solid #c7c7c7;
  border-radius: 5px;
}
.notBtn_lzNbU {
  transition: 0.5s;
  cursor: pointer;
}
.fas_X_XVb {
  font-size: 25pt;
  padding-bottom: 10px;
  color: black;
  margin-right: 40px;
  margin-left: 40px;
}
.box_jXYTl {
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
.fas_X_XVb:hover {
  color: #d63031;
}
.notBtn_lzNbU:hover > .box_jXYTl {
  height: 60vh;
}
.content_REhhO {
  padding: 20px;
  color: black;
  vertical-align: middle;
  text-align: left;
}
.top_fHXPK {
  color: black;
  padding: 10px;
}
.display_Ja6hd {
  position: relative;
}
.cont_U1XBC {
  position: relative;
  top: 0;
  width: 100%;
  height: 100%;
}
.cont_U1XBC:empty {
  display: none;
}
.stick_Mx5xC {
  text-align: center;
  display: block;
  font-size: 50pt;
  padding-top: 70px;
  padding-left: 80px;
}
.stick_Mx5xC:hover {
  color: black;
}
.cent_UQNTm {
  text-align: center;
  display: block;
}
.sec_fqFxI {
  padding: 10px 10px 5px 10px;
  transition: 0.5s;
}
.profile_CD8v1 {
  clip-path: circle(50% at 50% 50%);
  width: 50px;
  float: left;
}
.txt_Iu6fx {
  vertical-align: top;
  font-size: 14px;
  padding: 5px 5px 0px 60px;
  font-weight: 700;
}
.sub_y9UJ1 {
  vertical-align: top;
  padding: 5px 10px 0px 60px;
  font-size: 12;
  color: grey;
}
.new_XXTso {
  border-style: none none solid none;
  border-color: red;
}
.sec_fqFxI:hover {
  background-color: #bfbfbf;
}
.check_icon_blumi {
  display: flex;
  align-items: flex-end;
  right: 0;
}
.container_JTaJB {
  position: relative;
}
.checkIcon_hEkTj {
  opacity: 0;
  /* Initially hidden */
  transition: opacity 0.3s ease;
}
.sec_fqFxI:hover .checkIcon_hEkTj {
  opacity: 1;
  /* Show on hover */
}
.wrap_text_dnkBn {
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Notification/test.less"],"names":[],"mappings":"AAAA;EACI,oDAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AAEA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAGA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAIA;EACI,gBAAA;EACA,eAAA;AAFJ;AAKA;EACI,eAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;AAMA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AAJJ;AAOA;EACI,cAAA;AALJ;AAQA;EACI,YAAA;AANJ;AASA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAPJ;AAcA;EACI,YAAA;EACA,aAAA;AAZJ;AAeA;EACI,kBAAA;AAbJ;AAgBA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAdJ;AAkBA;EACI,aAAA;AAhBJ;AAmBA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjBJ;AAoBA;EACI,YAAA;AAlBJ;AAqBA;EACI,kBAAA;EACA,cAAA;AAnBJ;AAsBA;EACI,2BAAA;EACA,gBAAA;AApBJ;AAuBA;EAEI,iCAAA;EACA,WAAA;EACA,WAAA;AArBJ;AAwBA;EACI,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAtBJ;AAyBA;EACI,mBAAA;EACA,0BAAA;EACA,aAAA;EACA,WAAA;AAvBJ;AA0BA;EACI,kCAAA;EACA,iBAAA;AAxBJ;AA2BA;EACI,yBAAA;AAzBJ;AA4BA;EACI,aAAA;EACA,qBAAA;EACA,QAAA;AA1BJ;AA4BA;EACI,kBAAA;AA1BJ;AA6BA;EACI,UAAA;EA3BF,qBAAqB;EA4BnB,6BAAA;AA1BJ;AA6BA;EACI,UAAA;EA3BF,kBAAkB;AACpB;AA6BA;EACI,8BAAA;EACA,iCAAA;EACA,oCAAA;AA3BJ","sourcesContent":[".box::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #f5f5f5;\n    border-radius: 5px;\n}\n\n.box::-webkit-scrollbar {\n    width: 10px;\n    background-color: #f5f5f5;\n    border-radius: 5px;\n}\n\n.box::-webkit-scrollbar-thumb {\n    background-color: rgb(151, 151, 151);\n    border: 2px solid rgb(199, 199, 199);\n    border-radius: 5px;\n}\n\n.notBtn {\n    transition: 0.5s;\n    cursor: pointer;\n}\n\n.fas {\n    font-size: 25pt;\n    padding-bottom: 10px;\n    color: black;\n    margin-right: 40px;\n    margin-left: 40px;\n}\n\n.box {\n    width: 100%;\n    height: 400px;\n    overflow-y: auto;\n}\n\n.fas:hover {\n    color: #d63031;\n}\n\n.notBtn:hover > .box {\n    height: 60vh;\n}\n\n.content {\n    padding: 20px;\n    color: black;\n    vertical-align: middle;\n    text-align: left;\n}\n\n// .gry{\n//   background-color: #F4F4F4;\n// }\n\n.top {\n    color: black;\n    padding: 10px;\n}\n\n.display {\n    position: relative;\n}\n\n.cont {\n    position: relative;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    // background-color: #F4F4F4;\n}\n\n.cont:empty {\n    display: none;\n}\n\n.stick {\n    text-align: center;\n    display: block;\n    font-size: 50pt;\n    padding-top: 70px;\n    padding-left: 80px;\n}\n\n.stick:hover {\n    color: black;\n}\n\n.cent {\n    text-align: center;\n    display: block;\n}\n\n.sec {\n    padding: 10px 10px 5px 10px;\n    transition: 0.5s;\n}\n\n.profile {\n    -webkit-clip-path: circle(50% at 50% 50%);\n    clip-path: circle(50% at 50% 50%);\n    width: 50px;\n    float: left;\n}\n\n.txt {\n    vertical-align: top;\n    font-size: 14px;\n    padding: 5px 5px 0px 60px;\n    font-weight: 700;\n}\n\n.sub {\n    vertical-align: top;\n    padding: 5px 10px 0px 60px;\n    font-size: 12;\n    color: grey;\n}\n\n.new {\n    border-style: none none solid none;\n    border-color: red;\n}\n\n.sec:hover {\n    background-color: #bfbfbf;\n}\n\n.check_icon {\n    display: flex;\n    align-items: flex-end;\n    right: 0;\n}\n.container {\n    position: relative;\n}\n\n.checkIcon {\n    opacity: 0; /* Initially hidden */\n    transition: opacity 0.3s ease;\n}\n\n.sec:hover .checkIcon {\n    opacity: 1; /* Show on hover */\n}\n\n.wrap_text {\n    white-space: normal !important;\n    word-break: break-word !important;\n    overflow-wrap: break-word !important;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `box_jXYTl`,
	"notBtn": `notBtn_lzNbU`,
	"fas": `fas_X_XVb`,
	"content": `content_REhhO`,
	"top": `top_fHXPK`,
	"display": `display_Ja6hd`,
	"cont": `cont_U1XBC`,
	"stick": `stick_Mx5xC`,
	"cent": `cent_UQNTm`,
	"sec": `sec_fqFxI`,
	"profile": `profile_CD8v1`,
	"txt": `txt_Iu6fx`,
	"sub": `sub_y9UJ1`,
	"new": `new_XXTso`,
	"check_icon": `check_icon_blumi`,
	"container": `container_JTaJB`,
	"checkIcon": `checkIcon_hEkTj`,
	"wrap_text": `wrap_text_dnkBn`
};
export default ___CSS_LOADER_EXPORT___;
